import { Table } from "antd";
import { useTranslation } from "react-i18next";
import TableNumber from "../../../../../atoms/table-number";
import "./market-value-table.scss";

const MarketValueTable = () => {
  const { t } = useTranslation();

  const columns = [
    {
      title: "",
      dataIndex: "assets",
      key: "assets",
      width: 280,
      fixed: "left" as const,
      render: (text: any) => {
        let className;
        if (text.title === "Total Assets") {
          className = "bold-blue";
        } else if (text.title === "Total Liabilities") {
          className = "bold-black";
        } else if (
          text.title === "Share holder's Equity" ||
          text.title === "Off Balance Sheet"
        ) {
          className = "bold-blue";
        }

        return (
          <div className="assets">
            <div className={className}>{text.title}</div>
            {text.subTitle && (
              <div>
                <ul>
                  <li>{text.subTitle}</li>
                </ul>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "05/31/2024",
      children: [
        {
          title: t("AssetLiability.marketValue"),
          children: [
            {
              title: t("AssetLiability.actual"),
              dataIndex: "overnightActual",
              key: "overnightActual",
              //width: 150,
              align: "center" as const,
              render: (text: string) => <TableNumber value={text} />
            },
            {
              title: "+100bp",
              dataIndex: "overnightBp",
              key: "overnightBp",
              //width: 150,
              align: "center" as const,
              render: (text: string) => <TableNumber value={text} />
            },
          ],
        },
        {
          title: t("AssetLiability.durationInMonths"),
          dataIndex: "overnightDuration",
          key: "overnightDuration",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
        {
          title: t("AssetLiability.risk"),
          dataIndex: "overnightRisk",
          key: "overnightRisk",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
      ],
    },
    {
      title: "04/30/2024",
      children: [
        {
          title: t("AssetLiability.marketValue"),
          children: [
            {
              title: t("AssetLiability.actual"),
              align: "center" as const,
              dataIndex: "1mActual",
              key: "1mActual",
              render: (text: string) => <TableNumber value={text} />

              //width: 150,
            },
            {
              title: "+100bp",
              dataIndex: "1mBp",
              key: "1mBp",
              //width: 150,
              align: "center" as const,
              render: (text: string) => <TableNumber value={text} />
            },
          ],
        },
        {
          title: t("AssetLiability.durationInMonths"),
          dataIndex: "1mDuration",
          key: "1mDuration",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
        {
          title: t("AssetLiability.risk"),
          dataIndex: "1mRisk",
          key: "1mRisk",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
      ],
    },
    {
      title: t("AssetLiability.mtmVariance"),
      children: [
        {
          title: t("AssetLiability.durationInMonths"),
          dataIndex: "2mDuration",
          key: "2mDuration",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
        {
          title: t("AssetLiability.risk"),
          dataIndex: "2mRisk",
          key: "2mRisk",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
      ],
    },
  ];

  let id = 1;

  const data = [
    {
      id: id++,
      key: 1,
      assets: {
        title: "Placements",
        subTitle: "Due From Banks",
      },
      overnightActual: "5,572",
      overnightBp: "5,569",
      overnightDuration: "1",
      overnightRisk: "(3)",
      "1mActual": "6,354",
      "1mBp": "6,350",
      "1mDuration": "1",
      "1mRisk": "(4)",
      "2mDuration": "(0)",
      "2mRisk": "1",
    },
    {
      id: id++,
      key: 2,
      assets: {
        title: "",
        subTitle: "Loan To Banks",
      },
      "overnightActual": "3,357",
      "overnightBp": "3,346",
      "overnightDuration": "3",
      "overnightRisk": "(11)",
      "1mActual": "3,356",
      "1mBp": "3,343",
      "1mDuration": "4",
      "1mRisk": "(13)",
      "2mDuration": "(1)",
      "2mRisk": "2"
    },
    {
      id: id++,
      key: 3,
      assets: {
        title: "Loans",
        subTitle: "Wholesale Loans",
      },
      "overnightActual": "19,829",
      "overnightBp": "19,771",
      "overnightDuration": "2",
      "overnightRisk": "(58)",
      "1mActual": "19,470",
      "1mBp": "19,419",
      "1mDuration": "1",
      "1mRisk": "(51)",
      "2mDuration": "0",
      "2mRisk": "(7)"
    },
    {
      id: id++,
      key: 4,
      assets: {
        title: "",
        subTitle: "Commercial Loans",
      },
      "overnightActual": "72,080",
      "overnightBp": "71,497",
      "overnightDuration": "10",
      "overnightRisk": "(583)",
      "1mActual": "69,741",
      "1mBp": "69,163",
      "1mDuration": "10",
      "1mRisk": "(578)",
      "2mDuration": "(0)",
      "2mRisk": "(5)"
    },
    {
      id: id++,
      key: 5,
      assets: {
        title: "",
        subTitle: "Consumer Loans",
      },
      "overnightActual": "25,758",
      "overnightBp": "25,266",
      "overnightDuration": "23",
      "overnightRisk": "(492)",
      "1mActual": "25,737",
      "1mBp": "25,243",
      "1mDuration": "23",
      "1mRisk": "(494)",
      "2mDuration": "(0)",
      "2mRisk": "2"
    },
    {
      id: id++,
      key: 5,
      assets: {
        title: "",
        subTitle: "Mortgage Finance",
      },
      "overnightActual": "10,811",
      "overnightBp": "10,688",
      "overnightDuration": "12",
      "overnightRisk": "(123)",
      "1mActual": "10,293",
      "1mBp": "10,168",
      "1mDuration": "13",
      "1mRisk": "(125)",
      "2mDuration": "(1)",
      "2mRisk": "2"
    },
    {
      id: id++,
      key: 6,
      assets: {
        title: "",
        subTitle: "Credit Cards",
      },
      "overnightActual": "1,505",
      "overnightBp": "1,480",
      "overnightDuration": "20",
      "overnightRisk": "(25)",
      "1mActual": "1,468",
      "1mBp": "1,443",
      "1mDuration": "20",
      "1mRisk": "(24)",
      "2mDuration": "0",
      "2mRisk": "(0)"
    },
    {
      id: id++,
      key: 7,
      assets: {
        title: "",
        subTitle: "Overdrafts",
      },
      "overnightActual": "9,119",
      "overnightBp": "9,062",
      "overnightDuration": "0",
      "overnightRisk": "(57)",
      "1mActual": "9,011",
      "1mBp": "8,954",
      "1mDuration": "0",
      "1mRisk": "(57)",
      "2mDuration": "0",
      "2mRisk": "(1)"
    },
    {
      id: id++,
      key: 8,
      assets: {
        title: "Investments",
        subTitle: "T-Bills",
      },
      "overnightActual": "18,967",
      "overnightBp": "18,867",
      "overnightDuration": "6",
      "overnightRisk": "(99)",
      "1mActual": "19,484",
      "1mBp": "19,377",
      "1mDuration": "7",
      "1mRisk": "(107)",
      "2mDuration": "(0)",
      "2mRisk": "8"
    },
    {
      id: id++,
      key: 8,
      assets: {
        title: "",
        subTitle: "Bonds",
      },
      "overnightActual": "8,297",
      "overnightBp": "8,004",
      "overnightDuration": "44",
      "overnightRisk": "(293)",
      "1mActual": "8,163",
      "1mBp": "7,873",
      "1mDuration": "44",
      "1mRisk": "(290)",
      "2mDuration": "(0)",
      "2mRisk": "(3)"
    },
    {
      id: id++,
      key: 9,
      assets: {
        title: "",
        subTitle: "Corporate Bonds",
      },
      "overnightActual": "0",
      "overnightBp": "0",
      "overnightDuration": "0",
      "overnightRisk": "0",
      "1mActual": "0",
      "1mBp": "0",
      "1mDuration": "0",
      "1mRisk": "0",
      "2mDuration": "0",
      "2mRisk": "0"
    },
    {
      id: id++,
      key: 10,
      assets: {
        title: "",
        subTitle: "Floating Rate Notes",
      },
      "overnightActual": "4,571",
      "overnightBp": "4,563",
      "overnightDuration": "2",
      "overnightRisk": "(9)",
      "1mActual": "4,500",
      "1mBp": "4,490",
      "1mDuration": "3",
      "1mRisk": "(10)",
      "2mDuration": "(0)",
      "2mRisk": "1"
    },
    {
      id: id++,
      key: 11,
      assets: {
        title: "",
        subTitle: "Core Portfolio",
      },
      "overnightActual": "2,384",
      "overnightBp": "2,338",
      "overnightDuration": "24",
      "overnightRisk": "(46)",
      "1mActual": "2,407",
      "1mBp": "2,364",
      "1mDuration": "21",
      "1mRisk": "(42)",
      "2mDuration": "2",
      "2mRisk": "(3)"
    },
    {
      id: id++,
      key: 12,
      assets: {
        title: "",
        subTitle: "Grade Portfolio",
      },
      "overnightActual": "5,585",
      "overnightBp": "5,193",
      "overnightDuration": "91",
      "overnightRisk": "(393)",
      "1mActual": "5,541",
      "1mBp": "5,150",
      "1mDuration": "91",
      "1mRisk": "(390)",
      "2mDuration": "(0)",
      "2mRisk": "(2)"
    },
    {
      id: id++,
      key: 13,
      assets: {
        title: "",
        subTitle: "Certificate Of Deposit",
      },
      "overnightActual": "633",
      "overnightBp": "632",
      "overnightDuration": "2",
      "overnightRisk": "(1)",
      "1mActual": "262",
      "1mBp": "262",
      "1mDuration": "1",
      "1mRisk": "(0)",
      "2mDuration": "1",
      "2mRisk": "(1)"
    },
    {
      id: id++,
      key: 14,
      assets: {
        title: "Risk Sensitive Assets",
      },
      "overnightActual": "188,469",
      "overnightBp": "186,275",
      "overnightDuration": "14",
      "overnightRisk": "(2,193)",
      "1mActual": "196,770",
      "1mBp": "194,440",
      "1mDuration": "15",
      "1mRisk": "(2,330)",
      "2mDuration": "",
      "2mRisk": "(8)"
    },
    {
      id: id++,
      key: 15,
      assets: {
        title: "Cash & Statutory Deposits",
      },
      overnightActual: "",
      overnightBp: "",
      overnightDuration: "",
      overnightRisk: "",
      "1mActual": "",
      "1mBp": "",
      "1mDuration": "",
      "1mRisk": "",
      "2mDuration": "",
      "2mRisk": "",
    },
    {
      id: id++,
      key: 16,
      assets: {
        title: "Other Assets*",
      },
      overnightActual: "",
      overnightBp: "",
      overnightDuration: "",
      overnightRisk: "",
      "1mActual": "",
      "1mBp": "",
      "1mDuration": "",
      "1mRisk": "",
      "2mDuration": "",
      "2mRisk": "",
    },
    {
      id: id++,
      key: 17,
      assets: {
        title: "Total Assets",
      },
      overnightActual: " 188,469",
      overnightBp: "186,275",
      overnightDuration: "",
      overnightRisk: "",
      "1mActual": "196,770",
      "1mBp": "194,440",
      "1mDuration": "",
      "1mRisk": "",
      "2mDuration": "",
      "2mRisk": "",
    },
  ];

  const liabilitiesColumns = [
    {
      title: "",
      dataIndex: "assets",
      key: "assets",
      width: 280,
      fixed: "left" as const,
      render: (text: any) => {
        return (
          <div className="assets">
            <div className={text.title === "Total Assets" ? "bold-blue" : ""}>
              {text.title}
            </div>

            {text.subTitle && (
              <div>
                {" "}
                <ul>
                  <li>{text.subTitle}</li>
                </ul>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "05/31/2024",
      children: [
        {
          title: t("AssetLiability.marketValue"),
          children: [
            {
              title: t("AssetLiability.actual"),
              dataIndex: "overnightActual",
              key: "overnightActual",
              ////width: 150,
              align: "center" as const,
              render: (text: string) => <TableNumber value={text} />
            },
            {
              title: "+100bp",
              dataIndex: "overnightBp",
              key: "overnightBp",
              //width: 150,
              align: "center" as const,
              render: (text: string) => <TableNumber value={text} />
            },
          ],
        },
        {
          title: t("AssetLiability.durationInMonths"),
          dataIndex: "overnightDuration",
          key: "overnightDuration",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
        {
          title: t("AssetLiability.risk"),
          dataIndex: "overnightRisk",
          key: "overnightRisk",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
      ],
    },
    {
      title: "04/30/2024",
      children: [
        {
          title: t("AssetLiability.marketValue"),
          children: [
            {
              title: t("AssetLiability.actual"),
              align: "center" as const,
              dataIndex: "1mActual",
              key: "1mActual",
              //width: 150,
              render: (text: string) => <TableNumber value={text} />
            },
            {
              title: "+100bp",
              dataIndex: "1mBp",
              key: "1mBp",
              //width: 150,
              align: "center" as const,
              render: (text: string) => <TableNumber value={text} />
            },
          ],
        },
        {
          title: t("AssetLiability.durationInMonths"),
          dataIndex: "1mDuration",
          key: "1mDuration",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
        {
          title: t("AssetLiability.risk"),
          dataIndex: "1mRisk",
          key: "1mRisk",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
      ],
    },
    {
      title: t("AssetLiability.mtmVariance"),
      children: [
        {
          title: t("AssetLiability.durationInMonths"),
          dataIndex: "2mDuration",
          key: "2mDuration",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
        {
          title: t("AssetLiability.risk"),
          dataIndex: "2mRisk",
          key: "2mRisk",
          //width: 150,
          align: "center" as const,
          render: (text: string) => <TableNumber value={text} />
        },
      ],
    },
  ];

  const liabilitiesData = [
    {
      id: id++,
      "key": 1,
      "assets": {
        "title": "Deposits",
        "subTitle": "Fixed Deposits"
      },
      "overnightActual": "(84,542)",
      "overnightBp": "(84,335)",
      "overnightDuration": "2.95",
      "overnightRisk": "207",
      "1mActual": "(83,948)",
      "1mBp": "(83,729)",
      "1mDuration": "3.13",
      "1mRisk": "218",
      "2mDuration": "(0)",
      "2mRisk": "(11)"
    },
    {
      id: id++,
      "key": 2,
      "assets": {
        "title": "",
        "subTitle": "Call - Notice"
      },
      "overnightActual": "(71)",
      "overnightBp": "(71)",
      "overnightDuration": "0",
      "overnightRisk": "0",
      "1mActual": "(65)",
      "1mBp": "(65)",
      "1mDuration": "0",
      "1mRisk": "0",
      "2mDuration": "(0)",
      "2mRisk": "(0)"
    },
    {
      id: id++,
      "key": 3,
      "assets": {
        "title": "",
        "subTitle": "Customer Repos"
      },
      "overnightActual": "(589)",
      "overnightBp": "(589)",
      "overnightDuration": "0",
      "overnightRisk": "0",
      "1mActual": "(403)",
      "1mBp": "(403)",
      "1mDuration": "0",
      "1mRisk": "0",
      "2mDuration": "(0)",
      "2mRisk": "(0)"
    },
    {
      id: id++,
      "key": 4,
      "assets": {
        "title": "",
        "subTitle": "Savings"
      },
      "overnightActual": "(361)",
      "overnightBp": "(361)",
      "overnightDuration": "1",
      "overnightRisk": "0",
      "1mActual": "(360)",
      "1mBp": "(360)",
      "1mDuration": "1",
      "1mRisk": "0",
      "2mDuration": "0",
      "2mRisk": "(0)"
    },
    {
      id: id++,
      "key": 5,
      "assets": {
        "title": "Borrowings",
        "subTitle": "Due To banks"
      },
      "overnightActual": "(4,854)",
      "overnightBp": "(4,846)",
      "overnightDuration": "2",
      "overnightRisk": "8",
      "1mActual": "(6,658)",
      "1mBp": "(6,650)",
      "1mDuration": "2",
      "1mRisk": "9",
      "2mDuration": "0",
      "2mRisk": "(1)"
    },
    {
      id: id++,
      "key": 5,
      "assets": {
        "title": "Debt Security",
        "subTitle": ""
      },
      "overnightActual": "(4,167)",
      "overnightBp": "(4,154)",
      "overnightDuration": "1.4",
      "overnightRisk": "13",
      "1mActual": "(4,156)",
      "1mBp": "(4,146)",
      "1mDuration": "2.4",
      "1mRisk": "10",
      "2mDuration": "",
      "2mRisk": ""
    },
    {
      id: id++,
      "key": 6,
      "assets": {
        "title": "Risk Sensitive Liabilities",
        "subTitle": ""
      },
      "overnightActual": "(94,583)",
      "overnightBp": "(94,355)",
      "overnightDuration": "3",
      "overnightRisk": "228",
      "1mActual": "(95,591)",
      "1mBp": "(95,353)",
      "1mDuration": "3",
      "1mRisk": "238",
      "2mDuration": "",
      "2mRisk": "(12)"
    },
    {
      id: id++,
      "key": 7,
      "assets": {
        "title": "Deposits - NIB",
        "subTitle": ""
      },
      "overnightActual": "(63,486)",
      "overnightBp": "(63,486)",
      "overnightDuration": "",
      "overnightRisk": "",
      "1mActual": "(63,797)",
      "1mBp": "(63,797)",
      "1mDuration": "",
      "1mRisk": "",
      "2mDuration": "",
      "2mRisk": ""
    },
    {
      id: id++,
      "key": 8,
      "assets": {
        "title": "Other Liabilities",
        "subTitle": ""
      },
      "overnightActual": "",
      "overnightBp": "",
      "overnightDuration": "",
      "overnightRisk": "",
      "1mActual": "",
      "1mBp": "",
      "1mDuration": "",
      "1mRisk": "",
      "2mDuration": "",
      "2mRisk": ""
    },
    {
      id: id++,
      "key": 9,
      "assets": {
        "title": "Total Liabilities",
        "subTitle": ""
      },
      "overnightActual": "158,069",
      "overnightBp": "157,841",
      "overnightDuration": "",
      "overnightRisk": "",
      "1mActual": "159,388",
      "1mBp": "159,150",
      "1mDuration": "",
      "1mRisk": "",
      "2mDuration": "",
      "2mRisk": ""
    }
  ];

  const totalLiabilitiesData1 = [
    {
      id: id++,
      "key": 1,
      "assets": {
        "title": "Off Balance Sheet",
        "subTitle": ""
      },
      "overnightActual": "1",
      "overnightBp": "1",
      "overnightDuration": "1",
      "overnightRisk": "(0)",
      "1mActual": "1",
      "1mBp": "1",
      "1mDuration": "1",
      "1mRisk": "(0)",
      "2mDuration": "0",
      "2mRisk": "0"
    }
  ];

  const totalLiabilitiesData2 = [
    {
      id: id++,
      "key": 1,
      "assets": {
        "title": "Share holder's Equity",
        "subTitle": ""
      },
      "overnightActual": "0",
      "overnightBp": "(28,435)",
      "overnightDuration": "",
      "overnightRisk": "(1,965)",
      "1mActual": "0",
      "1mBp": "(35,290)",
      "1mDuration": "",
      "1mRisk": "(2,092)",
      "2mDuration": "",
      "2mRisk": "127"
    }
  ];

  return (
    <div className="market-value-wrapper">
      <div className="market-table">
        <div className="market-table__heading">
          {t("AssetLiability.marketRiskComparison")}
        </div>
        <div className="market-table__date">
          CAD {t("AssetLiability.inMillions")}
        </div>
        <div className="market-table__table">
          <Table
            columns={columns}
            dataSource={data}
            bordered
            scroll={{ x: 1360 }}
            pagination={false}
            rowClassName={(record, index) => {
              if (record.key === 14) {
                return "market-table__orange";
              } else if (record.key === 17) {
                return "market-table__bold-blue";
              } else if (
                index % 2 === 0 ||
                record.key === 15 ||
                record.key === 16
              ) {
                return "market-table__table__white";
              } else {
                return "market-table__light-blue";
              }
            }}
            rowKey="id"
          />
        </div>

        <div className="market-table__table liabilities">
          <Table
            columns={liabilitiesColumns}
            dataSource={liabilitiesData}
            bordered
            scroll={{ x: 1360 }}
            pagination={false}
            rowClassName={(record, index) => {
              if (record.key === 6) {
                return "market-table__orange";
              } else if (record.key === 9) {
                return "market-table__bold-blue";
              } else if (
                index % 2 === 0 &&
                record.key !== 8 &&
                record.key !== 9
              ) {
                return "market-table__light-blue";
              } else {
                return "market-table__white";
              }
            }}
            rowKey="id"
          />
        </div>

        <div className="market-table__table total-liabilities">
          <Table
            columns={columns}
            dataSource={totalLiabilitiesData1}
            bordered
            scroll={{ x: 1360 }}
            pagination={false}
            rowClassName="market-table__yellow"
            rowKey="id"
          />
        </div>

        <div className="market-table__table total-liabilities">
          <Table
            columns={columns}
            dataSource={totalLiabilitiesData2}
            bordered
            scroll={{ x: 1360 }}
            pagination={false}
            rowClassName="market-table__bold-blue"
            rowKey="id"
          />
        </div>

        <div className="other-assets">
          * Other Assets & ^ Other Liabilities comprises all non-risk sensitive
          items.
        </div>
      </div>
    </div>
  );
};

export default MarketValueTable;
